<template>
  <a-form
    ref="formState"
    :model="formState"
    :rules="rules"
    v-bind="{
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
    }"
  >
    <a-form-item label="项目名称">
      <a-input v-model:value="formState.projectName" type="text" />
    </a-form-item>
    <a-form-item label="项目编号">
      <a-input v-model:value="formState.projectNum" type="text" />
    </a-form-item>
    <a-form-item label="客户联系人">
      <a-select
        show-search
        placeholder="选择关联客户"
        option-filter-prop="children"
        style="width: 51vw"
        :filter-option="filterOption"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
        v-model:value="formState.customerId"
      >
        <a-select-option
          :key="index"
          v-for="(item, index) in customers"
          :value="item.id"
        >
          {{ item.name}}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="联系方式">
      <a-input v-model:value="formState.phone" type="text" />
    </a-form-item>
    <a-form-item label="备注:" name="remark">
      <a-input v-model:value="formState.remark" type="text" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="$confirm(target, formState)">确认</a-button>
      <a-button style="margin-left: 10px" @click="$reset(defaultState)">重置</a-button>
      <a-popconfirm
        v-if="id"
        title="确认删除？"
        @confirm="$del(id, true)"
      >
        <a-button
          style="margin-left: 10px"
          type="danger"
          >删除</a-button
        >
      </a-popconfirm>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  data() {
    return {
      id:"",
      target: null,
      targetName: 'project',
      defaultState: {},
      formState: {},
      customers: null,
    };
  },
  async mounted() {
    this.id = await this.$loadDetail();
    this.init();
  },

  methods: {
    async init() {
      const query = await new this.$lc.Query("customer");
      let data = await query.descending("createdAt").find();
     
      this.customers = data.map(item => {
        return {
            ...item.attributes,
            id: item.id
        };
      });
    },

    // 搜索客户
    filterOption(input, option) {
      console.log(input, option)
      return (
        option.children[0].children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
